import { Component, OnInit, ViewContainerRef, NgZone } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { AuthService } from './_services/auth.service';
import { Router } from '@angular/router';
import { DialogService } from './_services/dialog.service';
import { takeUntil } from 'rxjs/operators';
import { BsModalService } from 'ngx-bootstrap/modal';
import { InactivityMonitorService } from './_services/inactivity-monitor.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

  private _onDestroy$: Subject<void> = new Subject();

  constructor(
    private authService: AuthService,
    private router: Router,
    private dialogService: DialogService,
    private viewRef: ViewContainerRef,
    private modalService: BsModalService,
    private inactivityMonitor: InactivityMonitorService,
    private zone: NgZone) {

    }

  ngOnInit() {

    this.inactivityMonitor.timeout.subscribe(_ => this.logoutProcess());
  }

  logoutProcess () {

    this.authService.logout()
      .subscribe(
        () => {

          // close all open modals
          for (let i = 1; i <= this.modalService.getModalsCount(); i++) {

            this.modalService.hide(i);
          }

          // display message
          this.dialogService.alert(
            'Session Expired',
            `Your login session has expired`,
            this.viewRef);

          // let the message show for a moment before navigating away
          const logoutTimer = timer(2000, 5000).pipe(takeUntil(this._onDestroy$))
            .subscribe(
              () => {

                logoutTimer.unsubscribe();

                this.zone.run(() => this.router.navigate(['/login']));
              }
            );
        }
      );
  }
}
